export default "__VITE_ASSET__00ec4f1e__"